// Write your code here
import './index.css'

const Footer = () => (
  <div className="footer-container">
    <h1 className="footer-heading">Footer</h1>
  </div>
)

export default Footer
